import React from 'react';
import { Link } from 'react-router-dom';
import ListItemButton from '@mui/material/ListItemButton';
import Tooltip from '@mui/material/Tooltip';

const ListItemLink = ({
  tooltip,
  onClickHandler,
  subMenuList,
  moduleId,
  icon,
  label,
  adminOnly,
  divider,
  externalRedirect,
  button,
  ...props
}) => {
  const to = typeof props.to !== 'string' ? '' : props.to;

  const listItem = (
    <ListItemButton component={Link} {...{ ...props, to }} onClick={onClickHandler ?? null} />
  );

  if (tooltip) {
    return (
      <Tooltip title={tooltip} placement="right">
        {listItem}
      </Tooltip>
    );
  }

  return listItem;
};

export default ListItemLink;
